import { isAgentsEnabled } from "@hightouch/lib/llm/agents-tier";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useEntitlements } from "src/hooks/use-entitlement";
import { NavSection } from "src/components/layout/nav/nav-section";

import { Icon } from "src/components/layout/nav/icons/customer-studio";
import { ActiveSectionProps } from "src/components/layout/nav/utils";
import { useAgentsTier } from "src/pages/agents/hooks/use-agents-tier";
import { UseSectionHook } from "./types";

export const useCustomerStudioSection: UseSectionHook = () => {
  const { data: entitlementsData } = useEntitlements(false);
  const {
    appPerformancePage,
    appDestinationRulesEnabled,
    audienceTemplatesEnabled,
    appEnableGartnerDemo,
    appEnableProfileExplorer,
  } = useFlags();
  const agentsTier = useAgentsTier();

  const hasAudiencesEntitlement = entitlementsData.entitlements.audiences;

  if (isAgentsEnabled(agentsTier) && !hasAudiencesEntitlement) {
    // Agents users who don't have audiences entitlement will only see the schema link
    return {
      title: "Customer Studio",
      isEnabled: true,
      links: [
        {
          href: "/schema-v2",
          label: "Schema",
        },
      ],
    };
  }

  return {
    title: "Customer Studio",
    isEnabled: hasAudiencesEntitlement,
    links: [
      {
        href: "/audiences",
        label: "Audiences",
      },
      entitlementsData.entitlements.journeys && {
        href: "/journeys",
        label: "Journeys",
      },
      (appEnableGartnerDemo || appEnableProfileExplorer) && {
        href: "/profiles",
        label: "Profiles",
      },
      {
        href: "/priority-lists",
        label: "Priority lists",
      },
      appPerformancePage && {
        href: "/performance",
        label: "Performance",
      },
      {
        href: "/traits",
        label: "Traits",
      },
      {
        href: "/schema-v2",
        label: "Schema",
      },
      appDestinationRulesEnabled && {
        href: "/governance",
        label: "Governance",
      },
      audienceTemplatesEnabled && {
        href: "/templates",
        label: "Templates",
      },
    ],
  };
};

export const CustomerStudio = (props: ActiveSectionProps) => {
  const section = useCustomerStudioSection();
  return <NavSection icon={Icon} {...section} {...props} />;
};
